export default "__VITE_ASSET__CxM3le8e__"